const DEFAULT_ERROR = 'Something went wrong. Please try again.';

type Matcher = {
  category: 'myprofile journey';
  code: string;
  message: string;
};

const MATCHERS: Matcher[] = [
  {
    category: 'myprofile journey',
    code: 'ERR-001',
    message: 'Something went wrong! Please contact support for further assistance.',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-002',
    message: 'No valid session found',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-MFA-002',
    message: 'Required details missing! Contact support',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-EML-001',
    message: 'Unable to send OTP, Try again later',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-PAS-001',
    message: 'Verification Failed, Please try again.',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-PWD-012',
    message: 'The current password is incorrect. Please try again.',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-PWD-013',
    message: 'The new password cannot match any of your previous 5 passwords.',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-OTP-001',
    message: 'Invalid OTP. Please try again.',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-OTP-002',
    message: 'Exceeded number of retry attempts.',
  },
  {
    category: 'myprofile journey',
    code: 'ERR-EML-002',
    message: 'You have reached the maximum number of OTP resend attempts.',
  },
];

function extractErrorCode(raw: string): string {
  const normalized = raw.trim().toUpperCase();
  const directMatch = normalized.match(/^([A-Z]+(?:-[A-Z]+)?-\d{3})\b/);
  if (directMatch) {
    return directMatch[1];
  }

  return normalized
    .split(/[\s:_-]+/)
    .slice(0, 3)
    .join('-');
}

export function mapJourneyError(rawMessage: string | null | undefined): string {
  if (!rawMessage || !rawMessage.trim()) {
    return DEFAULT_ERROR;
  }

  const normalized = rawMessage.trim();
  const code = extractErrorCode(normalized);

  for (const matcher of MATCHERS) {
    if (matcher.code === code) {
      return matcher.message;
    }
  }

  return normalized;
}

export { DEFAULT_ERROR as DEFAULT_BUNDLED_ERROR_MESSAGE };
